var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9657 10.916L21.3727 9.50166L17.0844 0.682262C16.9673 0.440792 16.7746 0.245317 16.5366 0.126498C15.9396 -0.172464 15.2142 0.0766713 14.9157 0.682262L10.6274 9.50166L1.03443 10.916C0.769949 10.9543 0.52814 11.0808 0.343006 11.2724C0.119189 11.5058 -0.00414439 11.8198 0.000106342 12.1453C0.00435708 12.4709 0.135844 12.7814 0.365676 13.0087L7.30632 19.8734L5.66656 29.5667C5.62811 29.7921 5.6527 30.024 5.73756 30.2361C5.82242 30.4481 5.96414 30.6318 6.14666 30.7662C6.32917 30.9007 6.54518 30.9806 6.77019 30.9969C6.99519 31.0132 7.22019 30.9652 7.41967 30.8583L16.0001 26.2819L24.5805 30.8583C24.8147 30.9848 25.0868 31.027 25.3475 30.981C26.0049 30.866 26.4469 30.2336 26.3336 29.5667L24.6938 19.8734L31.6345 13.0087C31.8234 12.8209 31.9481 12.5756 31.9859 12.3073C32.0879 11.6366 31.6269 11.0156 30.9657 10.916Z",
    fill: "#F8DF00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.fc67ca122a7e2a9aeaa352f72258eba7.svg";
export { ForwardRef as ReactComponent };